module.exports = __webpack_public_path__ + "ptc_momoro_M2.83a52721.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_M2.jpg
// module id = /pKs
// module chunks = 0